module.exports = "https://www.gc-qa.gnp.com.mx/676592d1c3ca2187d0098c8311a5791d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-tramite.svg
// module id = 1841
// module chunks = 0